import { fromJS } from 'immutable';

export const RUNUP_SEARCH_TOGGLE_SECTION = 'RUNUP_SEARCH_TOGGLE_SECTION';

const initialState = fromJS({
  runupSourceInformationExpanded: true,
  tsunamiRunupLocationInformationExpanded: true,
  tsunamiRunupParametersEffectsInformationExpanded: true,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const runupSearchPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case RUNUP_SEARCH_TOGGLE_SECTION:
      return state.set(action.section, !state.get(action.section));
    default:
      return state;
  }
};
